import { animeList } from "@/mocks/anime";

const featuredIds = ["a01", "a03", "a05", "a14"];
const featured = animeList.filter((item) => featuredIds.includes(item.id));

const quickPoints = [
  { icon: "ri-calendar-2-line", label: "本周播出排期" },
  { icon: "ri-history-line", label: "最新话追踪" },
  { icon: "ri-bookmark-3-line", label: "连载追番进度" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20dreamy%20anime%20background%20of%20a%20pink%20cherry%20blossom%20path%20curving%20along%20a%20quiet%20town%20at%20sunset%2C%20soft%20rose%20and%20warm%20cream%20palette%2C%20bokeh%20lights%2C%20painterly%20illustration%20style%2C%20wide%20cinematic%20composition&width=1920&height=1080&seq=sakura-anime-hero-01&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/90 to-background-50"></div>
      </div>

      <div className="relative mx-auto max-w-[1280px] px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-36">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-flower-fill"></i>
            2026 秋季新番 · 每周持续更新
          </span>
          <h1 className="mt-4 font-heading text-3xl leading-tight text-foreground-950 md:text-5xl">
            樱花动漫在线：新番、更新与追番一站查看
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
            这里把本周新番排期、最新话更新、连载追番进度与分类检索整理在同一页面。无论是想确认今天更新什么，还是想按题材挑一部新番追下去，都能直接找到对应内容，不必在多处来回切换。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href="#weekly"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-calendar-2-line"></i>
              查看本周新番
            </a>
            <a
              href="#latest"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-history-line"></i>
              浏览最新话
            </a>
          </div>
          <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
            {quickPoints.map((point) => (
              <li key={point.label} className="flex items-center gap-2 text-sm text-foreground-700">
                <i className={`${point.icon} text-primary-600`}></i>
                {point.label}
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-12">
          <div className="mb-4 flex items-end justify-between gap-4">
            <h2 className="font-heading text-xl text-foreground-950 md:text-2xl">本季主打推荐</h2>
            <a href="#ranking" className="whitespace-nowrap text-sm text-primary-700 hover:text-primary-600">
              查看完整人气榜 →
            </a>
          </div>
          <div className="grid grid-cols-2 gap-4 md:gap-5 lg:grid-cols-4">
            {featured.map((item) => (
              <article
                key={item.id}
                className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="relative aspect-[3/4] w-full overflow-hidden">
                  <img
                    src={item.cover}
                    alt={`${item.title} 动画封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] text-background-50">
                    {item.year}
                  </span>
                  <span className="absolute bottom-2 right-2 flex items-center gap-1 rounded-md bg-primary-500 px-2 py-0.5 text-[11px] text-background-50">
                    <i className="ri-star-fill"></i>
                    {item.score}
                  </span>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="truncate text-sm font-medium text-foreground-950 md:text-base">{item.title}</h3>
                  <p className="mt-1 truncate text-xs text-foreground-600">{item.jpTitle}</p>
                  <div className="mt-2 flex items-center justify-between text-xs text-foreground-700">
                    <span className="truncate">{item.genres.join(" · ")}</span>
                    <span className="shrink-0 text-accent-700">更新至第 {item.latest} 话</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}